import React, { useEffect } from 'react';
import { LandingHero } from '../components/landing/LandingHero';
import { ComoFunciona } from '../components/landing/ComoFunciona';
import { PorQueBrixen } from '../components/landing/PorQueBrixen';
import { Testimonios } from '../components/landing/Testimonios';
import { LandingFAQ } from '../components/landing/LandingFAQ';
import { LandingFooter } from '../components/landing/LandingFooter';
export function HomePage() {
  useEffect(() => {
    document.title = 'Brixen Credit | Consultoría de Crédito en Español';
    window.scrollTo(0, 0);
  }, []);
  return <main className="w-full min-h-screen bg-white text-[#0A0A0A]" data-id="element-943">
      <LandingHero data-id="element-944" />
      <ComoFunciona data-id="element-945" />
      <PorQueBrixen data-id="element-946" />
      <Testimonios data-id="element-947" />
      <LandingFAQ data-id="element-948" />
      <LandingFooter data-id="element-949" />
    </main>;
}